"use strict";

exports.__esModule = true;
exports.ProfileContext = void 0;
var _Utils = require("../../../Utils");
var _ProfileController = require("./ProfileController");
var ProfileContext = exports.ProfileContext = (0, _Utils.createEnhancedContext)({
  propName: "profile",
  defaultController: _ProfileController.ProfileController
});